import React, { createRef } from "react";
import { Progress, InfiniteScroll, Button, printComponent } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";

import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import CardView from "../../../../../../components/common/CardView";
import Search from "../../../../../../components/Search";
import Table from "../../../../../../components/Table";

import NavBar from "../../../../../../components/navigation";
import { AttendeesCertificate } from "../print-certificate/AttendeesCertificate";
import TrainingAppearancePresenter from "./TrainingAppearancePresenter";
import PrintTrainingCertificate from "../print-certificate/PrintTrainingCertificate";

class TrainingApperance extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingAppearancePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      object: {},
      training: this.props.training,
      viewTraining: [],
      count: 0,
      limit: 10,
      current: 1,
      trainingObj: {},
    };
    this.iframeRef = createRef();
    this.contractPDF = React.createRef();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.training !== this.props.training) {
      await this.trainingData();
    }
  }

  async trainingData() {
    const { training } = this.props;
    console.log("HAHAHAH", training);
    const query = {
      where: {
        training: training,
      },
    };
    const viewTraining = await findObjectUseCase().execute(
      "certificate_appearance",
      query
    );
    console.log("SDLKFJSDG: ", viewTraining);
    this.setState({ viewTraining });
  }

  getCollectionName() {
    return "certificate_appearance";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  async AddTraining(object) {
    const query = {
      where: {
        id: object.id,
      },
    };
    const addTraining = await findObjectUseCase().execute(
      "certificate_appearance",
      query
    );
    for (const training of addTraining) {
      const { id, ...statTraining } = training;
      const enrolledData = { stats: "Enrolled", ...statTraining };
      console.log("APPPROVED");
      await upsertUseCase().execute("certificate_training", enrolledData);
      this.showSuccess("Training Successfully Added!");
      return this.refetchData();
    }
  }

  formatDate = (date) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };

  PrintCertificate = (object) => {
    this.setState({ trainingObj: object });
    printComponent(this.contractPDF.current, "Tasks");
  };

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, count, loading, current, limit } = this.state;
    const { training } = this.props;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "Firstname" &&
        fields !== "Middlename" &&
        fields !== "surname" &&
        fields !== "training" &&
        fields !== "stats"
    );

    if (!schema) return <Progress />;

    const generateCSV = () => {
      const { viewTraining } = this.state;
      let csvContent = "TRAINING, FIRST NAME, MIDDLE NAME, SURNAME\n"; // CSV header
      viewTraining.forEach((item) => {
        csvContent += `${item.training},${item.Firstname},${item.Middlename},${item.surname}\n`;
      });

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `Certificate of Appearance Report-${new Date()}.csv`
      );
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };

    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div className="d-none">
            <div ref={this.contractPDF} id="contractPDF">
              <PrintTrainingCertificate object={this.state.trainingObj} />
            </div>
          </div>
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Learning and Development &gt;{" "}
              <span style={{ color: "#333" }}>Certificate of Appearance</span>
            </p>
          </div>
          <div className="overflow-auto">
            <InfiniteScroll
              className="h-100"
              loadMore={this.loadMore.bind(this)}
              // hasMore={!progress && count > objects.length}
            >
              <div className="">
                <CardView style={{ borderRadius: 0 }}>
                  <Search
                    schemas={this.getSchemas()}
                    onSubmit={this.searchSubmit.bind(this)}
                    fields={schema.fields}
                  />
                </CardView>
                <br></br>

                <div
                  style={{
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <CardView style={{ borderRadius: 0 }}>
                    <div className="d-flex align-items-center">
                      <h4 className="text-primary">
                        Certificate of Appearance
                      </h4>
                      <div style={{ marginLeft: "auto" }}>
                        <Button onClick={() => generateCSV()}>
                          Download CSV
                        </Button>
                      </div>
                    </div>
                  </CardView>
                </div>

                <Table
                  progress={loading}
                  refetch={this.refetchData.bind(this)}
                  fields={schema.fields}
                  printTraining={this.PrintCertificate.bind(this)}
                  addTraining={this.AddTraining.bind(this)}
                  objects={this.state.viewTraining}
                  count={count}
                  limit={limit}
                  current={current}
                  loadPagination={this.onClickPagination.bind(this)}
                  collection={schema}
                  actionsList={[
                    {
                      label: <i className="bi bi-three-dots-vertical" />,
                      actionType: "Attendees List",
                    },
                  ]}
                  excludeFields={Object.keys(schema.fields).reduce(
                    (acc, key) => {
                      const options = schema.fields[key];
                      if (options.read === false) {
                        acc.push(key);
                      }
                      switch (options._type || options.type) {
                        case "Relation":
                        case "Array":
                        case "Object":
                        case "File":
                          acc.push(key);
                          break;
                        default:
                      }
                      return acc;
                    },
                    ["Id", "Created At", "Updated At", ...includeLabel]
                  )}
                  onClickItem={this.onClickItem.bind(this)}
                />
              </div>
            </InfiniteScroll>
          </div>
        </div>
        <iframe
          ref={this.iframeRef}
          style={{ display: "none" }}
          title="print-frame"
        />
      </>
    );
  }
}

export default TrainingApperance;
